import { ReactNode } from 'react';
import styles from './AboutUsModule.module.css';

export interface AboutUsModuleProps {
  background: 'tealSolid' | 'tealGradient' | 'white' | 'grey';
  children: ReactNode;
  /** Whether to add vertical padding, defaults to true, as that is the most common */
  verticalPadding?: boolean;
  /** Whether to add a reduced amount of vertical padding */
  withReducedPadding?: boolean;
  /** Whether to completely remove the padding, e.g. for non-standard layouts where a Module's content will define
   * the padding internally
   */
  withNoPadding?: boolean;
  /** Whether to remove only the top padding
   */
  withNoTopPadding?: boolean;
}

/** A "module" is a component that has a background colour that is the full width of the site. Generally, there is
 * spacing between modules of a different colour, with no additional padding between modules of the same colour */
const AboutUsModule = (props: AboutUsModuleProps) => (
  <div
    className={`${styles.module} ${props.verticalPadding == undefined || props.verticalPadding ? styles.withPadding : ''} ${props.withReducedPadding ? styles.withReducedPadding : ''} ${props.withNoPadding ? styles.withNoPadding : ''} ${props.withNoTopPadding ? styles.withNoTopPadding : ''} ${styles['moduleBackground__' + props.background]}`}
  >
    {props.children}
  </div>
);

export default AboutUsModule;
